import { Product } from "../../../../models/home-rows";
import { _c } from "../../../../services/text-services";
import AppFeatureList from "../feature-list/feature-list.component";
// @ts-ignore 
import styles from "./recommanded-products-row.component.module.scss";

interface AppRecommandedProductsRowProps {
  productsArray: Product[],
  title: string,
}

function AppRecommandedProductsRow({productsArray, title}: AppRecommandedProductsRowProps) {

  return <div
    className={_c(styles, "recommanded-products px-0")}
    >
    <div className={_c(styles,"d-flex justify-content-between align-items-end flex-column")}>
      <h2 className={_c(styles, "section-title")}>{title}</h2>
      <div className={_c(styles, "feature-container")}>
        <AppFeatureList productsArray={productsArray} title={title} />
      </div>
    </div>
  </div>
}

export default AppRecommandedProductsRow;